import { Inertia } from '@inertiajs/inertia'
import React, { useState, useEffect } from 'react'
import classNames from "classnames";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForm } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin';

const PasswordEdit = ({ item }) => {

    const { data, setData, post, processing, errors } = useForm({
        password: '',
        password_confirmation: '',
    })

    function submit(e) {
        e.preventDefault()
        post(route('advisers.password.update', item.id))
    }

    return (
        <Row>
            <h2 className="mb-4">Editar Contraseña de Asesor: {item.user.name} {item.lastname_ap} {item.lastname_am}</h2>
            <Container className="mb-5">
                <Form onSubmit={submit}>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <Form.Label>Nueva Contraseña</Form.Label>
                            <Form.Control type="password" autoComplete="off" onChange={e => setData('password', e.target.value)} className={classNames({ 'is-invalid': (errors.password) ? true : false, })} aria-invalid={errors.password ? "true" : "false"} />
                            {errors.password && <div className="mt-2 text-danger">{errors.password}</div>}
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>Confirmar Contraseña</Form.Label>
                            <Form.Control type="password" autoComplete="off" onChange={e => setData('password_confirmation', e.target.value)} className={classNames({ 'is-invalid': (errors.password_confirmation) ? true : false, })} aria-invalid={errors.password_confirmation ? "true" : "false"} />
                            {errors.password_confirmation && <div className="mt-2 text-danger">{errors.password_confirmation}</div>}
                        </Form.Group>
                    </Row>

                    <div className="mt-3">
                        <Button variant="primary" className='me-3' disabled={processing} type="submit">Guardar</Button>
                        <Button onClick={() => window.history.back()} variant="secondary" type="normal">Regresar</Button>
                    </div>
                </Form>
            </Container>
        </Row>
    );
}

PasswordEdit.layout = page => <Layout children={page} title="Editar Contraseña de Asesor" />

export default PasswordEdit
